import { render, staticRenderFns } from "./CalendarDashboard.vue?vue&type=template&id=219e9ab6&"
import script from "./CalendarDashboard.vue?vue&type=script&lang=js&"
export * from "./CalendarDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports